var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.statePortal
    ? _c(
        "section",
        { class: ["customer-portal-container"] },
        [
          _vm.showAdvice
            ? _c("StaticAlertComponent", {
                staticClass: "static-alert",
                attrs: { alert: _vm.alertData },
              })
            : _vm._e(),
          _c("p", {
            staticClass: "intro-text",
            domProps: {
              innerHTML: _vm._s(
                _vm.$t("components.customer_portal.introduction")
              ),
            },
          }),
          _c("ValidationObserver", {
            ref: "emailInput",
            staticClass: "email-field",
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ validate }) {
                    return [
                      _c("LexonTextFieldComponent", {
                        attrs: {
                          label: "Email",
                          id: "email",
                          name: "email",
                          type: "text",
                          validationRules: "required|email",
                          disabled: !_vm.canSave,
                        },
                        model: {
                          value: _vm.email,
                          callback: function ($$v) {
                            _vm.email = $$v
                          },
                          expression: "email",
                        },
                      }),
                    ]
                  },
                },
              ],
              null,
              false,
              703820707
            ),
          }),
          _c("div", { staticClass: "container-buttons" }, [
            _vm.credentialsSent && _vm.canSave
              ? _c(
                  "button",
                  {
                    staticClass: "secondary-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.askIfWantToDeleteAccess.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _c("span", { class: _vm.icons.remove }),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          this.$t("components.customer_portal.remove_access")
                        )
                      ),
                    ]),
                  ]
                )
              : _vm._e(),
            _vm.accessExists && _vm.canSave
              ? _c(
                  "button",
                  {
                    class: [
                      { "activate-access": _vm.blockedAccess },
                      "secondary-btn",
                    ],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.lockOrUnlockPortalAccess.apply(
                          null,
                          arguments
                        )
                      },
                    },
                  },
                  [
                    _c("span", { class: _vm.icons.lock }),
                    _c("span", [
                      _vm._v(_vm._s(_vm.renderedSecondaryButtonText)),
                    ]),
                  ]
                )
              : _vm._e(),
          ]),
          _c("div", { staticClass: "btn-area" }, [
            _vm.canSave
              ? _c(
                  "button",
                  {
                    staticClass: "primary-btn",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.executeMainAction.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.renderedPrimaryButtonText))]
                )
              : _vm._e(),
          ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }